module.exports = __webpack_public_path__ + "img/icone_vivescia.5a72f7e2.png";